module.exports = __webpack_public_path__ + "img/gd.56fdbab2.svg";